import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// ── Canales de mensajería registrados (2026-08-25) ───────────────────────────
// Registrado ≠ autorizado en Composio. Confundirlos es lo que hizo que un
// cliente creyera tener Facebook conectado una semana sin recibir un mensaje.

export interface CanalRegistrado {
  id: number;
  platform: string;
  label: string;
  externalId: string;
  enabled: boolean;
  verifiedAt: string | null;
  connectionStatus: string;
  listo: boolean;
  motivoNoListo: string | null;
}

export interface CanalCandidato {
  platform: string;
  externalId: string;
  label: string;
  canMessage: boolean;
  yaRegistrado: boolean;
}

const KEY = ['messaging-channels'];

export function useMessagingChannels() {
  return useQuery<{ channels: CanalRegistrado[] }>({
    queryKey: KEY,
    queryFn: () => api.get('/api/messaging-channels'),
    staleTime: 60_000,
  });
}

/** Las opciones salen de una llamada a Composio: se piden por acción explícita,
 *  no en cada carga de la pantalla. */
export function useChannelOptions() {
  return useMutation({
    mutationFn: (platform: string) =>
      api.get<{ candidatos: CanalCandidato[] }>(`/api/messaging-channels/options/${platform}`),
  });
}

export function useRegisterChannel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { platform: string; externalId: string }) =>
      api.post<CanalRegistrado>('/api/messaging-channels', input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
      // El paso "conexiones" de la inducción se deriva de esto.
      void qc.invalidateQueries({ queryKey: ['onboarding'] });
    },
  });
}

export function useDisableChannel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete<CanalRegistrado>(`/api/messaging-channels/${id}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
      void qc.invalidateQueries({ queryKey: ['onboarding'] });
    },
  });
}
